import {View} from 'native-base';
import React from 'react';

import OfferFilterDatesToggle from '../FilterDates/Toggle';

const OfferFilterDatesList: React.FC = () => {
  return (
    <View flex={1}>
      <OfferFilterDatesToggle isModal={true} />
    </View>
  );
};

export default OfferFilterDatesList;
